<!-- 产品管理 -->

<template>
  <div class="c-success-case">
    <ul class="c-profile-list">
      <li>
        <p class="c-profile-lf-txt"><em>*</em>产品名称 </p>
        <div class="c-profile-rt-input">
          <input v-model="productname" type="text" placeholder="请填写产品名称">
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>专业领域</p>
        <div class="c-profile-rt-input">
          <select class="select-box" v-model="selzy">
            <option v-for="key,index in zyly" :value="index">{{key}}</option>
          </select>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>细分领域</p>
        <div class="c-profile-rt-input">
          <select class="select-box" v-model="selxf">
            <option v-for="key,index in xfly[selzy]" :value="index">{{key}}</option>
          </select>
        </div>
      </li>
      <!-- <li>
        <p class="c-profile-lf-txt"><em>*</em>产品分类</p>
        <div class="c-profile-rt-input">



          <NewConstructor :selectedOptions="industrycategory" v-on:dataChange="handleNewConstructorChange" />

        </div>
      </li> -->
      <li>
        <p class="c-profile-lf-txt"><em>*</em>产品定价</p>
        <div class="c-profile-rt-input">
          <input class="product-pricing" v-model="amountlower" type="text" placeholder="">&nbsp;&nbsp;<span class="yuan">至</span>
          <input class="product-pricing" v-model="amountupper" type="text" placeholder="">&nbsp;&nbsp;<span class="yuan">元</span>
          <input v-model="priceDiscuss" id="priceDiscuss" style="width: 15px;margin: 0 10px;" type="checkbox" value=""><label
            for="priceDiscuss">价格面议</label>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt">详情描述</p>
        <div class="c-profile-rt-input">
          <textarea v-model="productdetail" placeholder="描述产品详情：不超过300字"></textarea>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>产品配图</p>
        <div class="c-profile-rt-input">
          <div class="c-profile-file">
            <img v-for="(img, index) in imgPreviews" :key="index" :src="img">
            <!-- <img src="../../assets/main/icon15@2x.png"> -->
            <div class="file-btn">
              <img src="../../assets/main/failbg.png">
              <Upload v-if="imgPreviews.length < 5" class="file-btn__upload" accept="image/png, image/jpeg"
                v-on:resetImageName="resetImageName" btnText="上传配图">
                <span class="file-btn__upload-btn"></span>
              </Upload>
            </div>
          </div>
          <p class="c-file-tips">最佳尺寸230*230，每张不超过2M，图片类型必须是jpg,png的一种。</p>
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt">联系地址</p>
        <div class="c-profile-rt-input c-profile-rt-input2">
          <div style="display: inline-block;float:left;margin-right:20px;">
            <CityCascader placeholderstr="选择省市" v-on:resetDefaultValue="setAddress" :defaultlevel1name="province"
              :defaultlevel2name="district"></CityCascader>
          </div>
          <input v-model="address" type="text" placeholder="请输入详细地址">
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>联系人</p>
        <div class="c-profile-rt-input">
          <input v-model="contacts" type="text" placeholder="联系人">
        </div>
      </li>
      <li>
        <p class="c-profile-lf-txt"><em>*</em>联系电话</p>
        <div class="c-profile-rt-input">
          <input v-model="mobile" type="text" placeholder="联系电话">
        </div>
      </li>
    </ul>

    <div class="sbumit-btn-box">
      <button @click="createProduct" class="submit-btn">提交</button>
      <button @click="backOrg" class="submit-btn cancel-btn">取消</button>
    </div>
  </div>
</template>

<script>
  import {
    addProduct,
    modifyProduct,
    getProductById,
  } from '@/api/product';
  import Upload from '@/components/common/Upload';
  import CityCascader from '@/components/common/MyCascader/city'
  import config from '@/config/index';
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  import NewConstructor from './components/NewConstructor'
  export default {
    name: 'ProductManager',
    props: {
      msg: String,
    },
    components: {
      NewConstructor,
      CityCascader,
      Upload,
    },
    data() {
      return {
        productInfo: {},
        productname: '',
        producttype: '',
        pid: '',
        orgid: '',
        productdetail: '', // 产品详情
        amountlower: 0, //   金额下限
        amountupper: 0, //   金额上限
        nonamount: 0, //     金额面议标识 1生效
        show: false, //          是否显示
        img: '', //           图片
        contacts: '', //      联系人
        mobile: '', // 手机号
        address: '', //       地址
        province: '', //      省份
        district: '', //      地区
        priceDiscuss: false,
        provcity: {},
        imgKeys: [],
        imgPreviews: [],
        industrycategory: '',
        checkedNewConstructors: [],
        zyly: ['智慧应用', '数据智能', '生态系统', '可信安全', '新型网络', '智慧专区', '数字上云', '金融服务'],
        xfly: {
          0: ['智慧政务应用', '智慧城市应用', '智慧民生应用', '智慧产业应用', '传统基础设施赋能', '中小企业赋能'],
          1: ['数据中心', '云边端', '大数据平台', '人工智能', '区块链服务平台', '数据交易'],
          2: ['产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台'],
          3: ['基础安全能力', '行业应用安全', '新型安全服务平台'],
          4: ['5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网'],
          5: ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
          6: ['云计算', '域名', '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'],
          7: ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
        },
        selzy: 0,
        selxf: 0,
        projectImgs: {
          project1yy: [
            '智慧政务应用',
            '智慧城市应用',
            '智慧民生应用',
            '智慧产业应用',
            '传统基础设施赋能',
            '中小企业赋能',
          ],
          project2zn: [
            '数据中心',
            '云边端',
            '大数据平台',
            '人工智能',
            '区块链服务平台',
            '数据交易'
          ],
          project3st: [
            '产业园区生态', '共性支撑软件', '科学仪器', '中试服务生态', '共享开源平台',
          ],
          project4aq: [
            '基础安全能力', '行业应用安全', '新型安全服务平台',
          ],
          project5wl: [
            '5G网络', '千兆固网', '卫星互联网', '车联网', '工业互联网', '政务专网',
          ],
          project6zq: ['智慧住建', '智慧园区', '智慧社区', '智慧出行', '智慧家居', '智慧健康', '智慧教育', '智慧政务'],
          project7sy: ['云计算', '域名',
            '内容安全', '网络', '存储与CDN', 'AI开放服务', '数据库', '其它产品服务提供商'
          ],
          project8jr: ['银行服务', '风险投资', '投资基金', '融资担保', '债券股票', '民间借贷']
        },
      }
    },
    watch: {
      selxf(n, o) {
        let type = this.xfly[this.selzy][n]
        this.changeImg(type)
      }
    },
    mounted() {
      this.orgid = this.$route.query.orgid;
      this.pid = this.$route.query.pid;
      this.queryProductInfo(this.pid);
      let ty = this.xfly[this.selzy][this.selxf]
      this.changeImg(ty)
    },
    methods: {
      changeImg(ty) {
        var type = ty.replace(/(^;)|(;$)/g, '');
        for (var img in this.projectImgs) {
          var keys = this.projectImgs[img]
          for (var i = 0; i < keys.length; i++) {
            if (type === keys[i]) {
              this.resetImageName(`project/${img}.png`)
              console.log("this.imgPreviews----", this.imgPreviews)
              return
            }
          }
        }
      },
      resetImageName(key) {
        if (this.imgKeys.length > 0) {
          this.imgKeys.splice(0, 1)
        }
        if (this.imgPreviews.length > 0) {
          this.imgPreviews.splice(0, 1)
        }

        this.imgKeys.push(key);
        this.imgPreviews.push(`${config.HOST_IMG}${key}`);
      },
      setAddress(address) {
        this.provcity = address;
        this.province = this.provcity.provName;
        this.district = this.provcity.areaName;
      },
      queryProductInfo(pid) {
        if (!pid) return;
        this.$http.get(getProductById(pid)).then((res) => {
          if (res.code === 1) {
            console.log(res);
            this.productInfo = res.data;
            this.initData();
          }
        });
      },
      initData() {
        if (this.productInfo) {
          const keys = Object.keys(this.productInfo);
          keys.forEach((key) => {
            this[key] = this.productInfo[key];
          });
          if (this.img && typeof this.img === 'string') {
            let imgs = JSON.parse(this.img);
            this.imgKeys = imgs;
            if (imgs && imgs.length > 0) {
              imgs = imgs.map((img) => {
                return `${config.HOST_IMG}${img}`;
              });
            }
            this.imgPreviews = imgs;
          }
          this.priceDiscuss = this.nonamount === 1;
          this.industrycategory = this.producttype
        }
      },
      backOrg() {
        this.$router.push('org?hasData=true');
      },
      getCheckedCategories() {
        return this.checkedNewConstructors
      },
      handleNewConstructorChange(param) {
        console.log("handleNewConstructorChange", param)
        this.industrycategory = param
      },
      getParams() {
        return {
          pid: this.pid,
          productname: this.productname,
          producttype: this.xfly[this.selzy][this.selxf], //this.industrycategory,
          orgid: this.orgid,
          productdetail: this.productdetail, // 产品详情
          amountlower: this.amountlower, //   金额下限
          amountupper: this.amountupper, //   金额上限
          nonamount: this.priceDiscuss ? 1 : 0, //     金额面议标识 1生效
          show: 0, //          是否显示
          // img: '', //           图片
          img: JSON.stringify(this.imgKeys), //           图片
          contacts: this.contacts, //      联系人
          mobile: this.mobile, // 手机号
          address: this.address, //       地址
          province: this.province, //      省份
          district: this.district, //      地区
        }
      },
      createProduct() {
        const params = this.getParams();
        if (this.pid) {
          this.$http.post(modifyProduct(), params, {
            uid: getCacheUserInfo().uid
          }).then(res => {
            console.log(res);
            if (res.code === 1) {
              this.$router.push('org');
            }
          });
        } else {
          this.$http.post(addProduct(), params, {
            uid: getCacheUserInfo().uid
          }).then(res => {
            console.log(res);
            if (res.code === 1) {
              this.$router.push('org');
            }
          });
        }

      },
      updateProduct() {

      },

    }
  };
</script>

<style scoped>
  @import url(./main.css);

  .file-btn {
    position: relative;
  }

  .file-btn__upload {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
  }

  .file-btn__upload-btn {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
  }
</style>
